<template>
  <div style="display: flex; flex-direction: column">
    <el-checkbox v-model="job.warehousing" @change="onChange('warehousing')">{{ $t("SeaExport.WarehouseLoadingStorage") }}</el-checkbox>
    <el-checkbox v-model="job.landTransportation" @change="onChange('landTransportation')">{{ $t("SeaExport.DoorLoadingDelivery") }}</el-checkbox>
    <el-checkbox v-model="job.selfDeliver" @change="onChange('selfDeliver')">{{ $t("SeaExport.NotResponsibleForTruckingAndLoading") }}</el-checkbox>
    <el-checkbox v-model="job.backUpWarehouse" @change="onChange('backUpWarehouse')">{{ $t("SeaExport.BackUpWarehouse") }}</el-checkbox>
    <el-checkbox v-model="job.otherService" @change="onChange('otherService')">{{ $t("SeaExport.Other") }}</el-checkbox>
    <el-input v-show="job.otherService" v-model="job.otherRemark" maxlength="10" @change="onChange('otherRemark')" />
  </div>
</template>

<script>
export default {
  name: 'SeLocalService',
  props: {
    job: { type: Object, default: () => { return {} } }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
